import React from 'react';
import styled from 'styled-components';
import bug from '../../assets/images/b-150-bug.png';

const BugContainer = styled.div`
  width: 100%;
  margin: 4rem auto 1rem;
  display: block;
  text-align: center;
  @media (max-width: 1000px) {
    margin: 2rem auto 1rem;
  }
  img {
    width: 100px;
    @media (max-width: 800px) {
      width: 74px;
    }
  }
  a {
    text-decoration: none !important;
  }
`;

const B150Bug = () => (
  <BugContainer>
    <a href="https://www.bostonglobe.com/special-projects/globe-150/">
      <img src={bug} alt="Boston Globe 150 years logo" />
    </a>
  </BugContainer>
);

export default B150Bug;
